<mat-grid-list cols="3" rowHeight="150px" gutterSize="20px" tnbResponsiveGrid>
  @for (aggregation of aggregations; track aggregation.anlagentyp) {
    <mat-grid-tile
      >
      <tnb-aggregation-tile
        [aggregation]="aggregation"
        [leistungseinheit]="leistungseinheit">
      </tnb-aggregation-tile>
    </mat-grid-tile>
  }
</mat-grid-list>
